import { render, staticRenderFns } from "./MechanicAssetPositionFormFields.vue?vue&type=template&id=60a9fe17&"
import script from "./MechanicAssetPositionFormFields.vue?vue&type=script&lang=js&"
export * from "./MechanicAssetPositionFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports